import React from 'react';
import './AccessDeniedNotice.css';

/**
 * YETKİSİZ ERİŞİM BİLDİRİMİ — "boş ekran" ile "kapalı ekran" ayrımı.
 *
 * Talep: kullanıcı yetkisi olmayan bir bölümü açtığında ekran boş kalıyor ya da genel bir
 * "veri alınamadı" hatası çıkıyordu; bunu ARIZA sanıp destek kaydı açıyorlardı. Yetkisizlik bir
 * hata değildir — kullanıcıya ne olduğu ve ne yapması gerektiği AÇIKÇA söylenmelidir.
 *
 * Bilinçli olarak "hata" gibi (kırmızı/uyarı) DEĞİL, nötr bilgi tonunda çizilir: sistem
 * beklendiği gibi çalışıyor, kullanıcının o veriye erişimi yok.
 *
 * @param {string} [title]  Başlık; varsayılan genel metindir.
 * @param {string} [detail] Hangi bölüm olduğunu söyleyen ek cümle (ör. "Giriş hareketleri").
 */
export function AccessDeniedNotice({ title, detail }) {
  return (
    <div className="access-denied" role="status">
      <span className="access-denied-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
             strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </span>
      <div>
        <div className="access-denied-title">
          {title || 'Bu bilgiyi görme yetkiniz yok'}
        </div>
        <div className="access-denied-detail">
          {detail ? `${detail} ` : ''}
          Erişim gerekiyorsa lütfen yöneticinizle görüşün.
        </div>
      </div>
    </div>
  );
}

export default AccessDeniedNotice;
